export const STORAGE = {
    AUTO_MODAL_INFO: 'checkoutAutoModalInfo',
    SURVEY_INFO: 'checkoutSurveyInfo',
};
